import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonDefinitionService } from '../common/common-definition.service';
import { CommonDeclarationService } from '../common/common-declaration.service';
import { NetworkService } from '../network/network.service';
import { NavController, Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';
import * as CryptoJS from 'crypto-js';
import { Base64 } from '@ionic-native/base64/ngx';
@Injectable({
  providedIn: 'root'
})
export class RestapiService {
  Url: any;
  headers: any;
  errData: any;
  metaData: any;
  AESKey: any = 'dAtAbAsE98765432';
  basetext: any;

  constructor(public http: HttpClient, public network: NetworkService, public cmndefinition: CommonDefinitionService, public cmndecl: CommonDeclarationService, public navctrl: NavController, public platform: Platform, public push: Push, public router: Router, private base64: Base64) {

    this.Url = this.cmndecl.baseUrl + this.cmndecl.versionUrl + this.cmndecl.apiUrl;
    this.metaData = {
      "channelId": "1" || "",
      "ip": "",
      "imei": "",
      "platform": this.cmndecl.runPlatform,
      "deviceVersion": "8.0",
      "deviceModel": "Mobile",
      "version": this.cmndecl.versionNo
    }
    this.errData = {
      "sorry": "no response"
    };

    this.platform.ready().then(() => {

      // this.setPushData();
    });
  }

  formheader() {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'VW5pcGhvcmVfTWV0bGlmZToxMjM0NTYkJCQ=',
      'Access-Control-Allow-Origin': "*"
    });
  }

  /*****************************************************
   Date            Version         Name         Description    
   21-OCT-2019     1.0             Gokul        Initial setup
   ******************************************************/

  async postapi(path: any, data: any) {
    data["langCode"] = "en";
    if (this.cmndecl.metadata == undefined || this.cmndecl.metadata == "") {
      data["metadata"] = this.metaData;
    } else {
      data["metadata"] = this.cmndecl.metadata;
    }
    var convertData = JSON.stringify(data);
    console.log(convertData);



    var secretThree = CryptoJS.enc.Utf8.parse(this.AESKey.toString().substring(0, 32));

    var encryptedData = CryptoJS.AES.encrypt(convertData, secretThree, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    var encryptedText = encryptedData.ciphertext.toString(CryptoJS.enc.Base64);
    console.log(encryptedText);
    var json = {
      value: encryptedText
    };
    let response: any;
    if (this.cmndefinition.DisplayLoader.indexOf(path) != -1) {
      await this.cmndefinition.loaderstart();
    }
    await this.formheader();
    return new Promise(async (resolve, reject) => {
      if (this.cmndecl.Networkstatus) {
        await this.http.post(this.Url + path, json, { headers: this.headers }).subscribe(async data => {
          if (this.cmndefinition.DisplayLoader.indexOf(path) != -1) {
            await this.cmndefinition.loaderend();
          }
          response = data;

          var getdata = response.value;
          console.log(getdata);
          var secretThree = CryptoJS.enc.Utf8.parse(this.AESKey.toString().substring(0, 32));
          var decryptedData = CryptoJS.AES.decrypt(getdata, secretThree, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          });

          var decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
          var JSONParse = JSON.parse(decryptedText);

          if (JSONParse == null) {
            return false;
          }

          if (JSONParse.JSONParseCode == "002") {
            if (JSONParse.message == undefined || JSONParse.message == "") {
              reject(this.errData)
            }
            else {
              if (JSONParse.header) {
                this.cmndefinition.presentAlert(JSONParse.header, JSONParse.message, "otperror");
                reject(JSONParse);
              } else {
                if (JSONParse.message == "OTP entered is incorrect Please try again") {
                  this.cmndefinition.presentAlert("Incorrect OTP", JSONParse.message, "otperror");
                  reject(JSONParse);
                }
                else if (JSONParse.message == "एंटर्ड ओटीपी सही नहीं है कृपया फिर से प्रयास करें") {
                  this.cmndefinition.presentAlert("इनकरेक्ट ओटीपी", JSONParse.message, "otperror");
                  reject(JSONParse);
                } else {
                  this.cmndefinition.presentAlert("", JSONParse.message, JSONParse.status);
                  reject(JSONParse);
                }
              }
            }
          } else
            resolve(JSONParse);
        }, async (err: any) => {
          setTimeout(async () => {
            if (err.status == 0 && err.statusText == 'Unknown Error') {
              sessionStorage.CurrentPage = '/pagenotfound';
              this.navctrl.navigateRoot("/pagenotfound");
            }
          }, 3000);
        });
      } else {
        if (this.cmndecl.LanguageJson != undefined && this.cmndecl.LanguageJson != "")
          this.cmndefinition.Showtoast(this.cmndecl.LanguageJson.pages[0].alerts.unablenetwork);
        else {
          if (localStorage.language == "en")
            this.cmndefinition.Showtoast("Seems like you are in a low network. Please check your internet connection and try again");
          else
            this.cmndefinition.Showtoast("लगता है कि आप कम नेटवर्क में हैं। कृपया अपना इंटरनेट कनेक्शन चेक करें और फिर से कोशिश करे");
        }

        if (this.cmndefinition.DisplayLoader.indexOf(path) != -1) {
          await this.cmndefinition.loaderend();
        }
      }
    });
  }


  async initSession() {
    let data: any;
    let response: any;
    await this.formheader();

    return new Promise(async (resolve, reject) => {
      await this.http.post(this.Url + "webbotInitsession", data, { headers: this.headers }).subscribe(async data => {
        response = data;

        var getdata = response.value;
        console.log(getdata);
        var secretThree = CryptoJS.enc.Utf8.parse(this.AESKey.toString().substring(0, 32));
        var decryptedData = CryptoJS.AES.decrypt(getdata, secretThree, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        });

        var decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
        var JSONParse = JSON.parse(decryptedText);

        localStorage.setItem('userChatSessionId', JSONParse.UserChatId);
        localStorage.setItem('userSessionId', JSONParse.UserSessionId);
        resolve(JSONParse);
      }, async (err: any) => {
        setTimeout(async () => {
          if (err.status == 0 && err.statusText == 'Unknown Error') {

            sessionStorage.CurrentPage = '/pagenotfound';
            this.navctrl.navigateRoot("/pagenotfound");

          }
        }, 3000);
      })
    })
    // await this.http.post(this.Url + "webbotInitsession", data, { headers: this.headers }).subscribe(data => {
    //   
    //   
    //   localStorage.setItem('userChatSessionId', data["UserChatId"]);
    //   localStorage.setItem('userSessionId', data["UserSessionId"]);
    // }, err => {
    //   
    // })
  }

  async clickenventcap(menuName: any) {
    let data: any;
    await this.formheader();
    data = {
      "userChatSessionID": localStorage.userChatSessionId,
      "userSessionID": localStorage.userSessionId,
      "clickMenu": [{
        "count": 1,
        "menuName": menuName
      }],
      "langCode": "en",
      "metadata": this.cmndecl.metadata
    }

    this.http.post(this.Url + "webbotcaptureClickEvent", data, { headers: this.headers }).subscribe(data => {

    }, err => {

    })
  }

  setPushData() {
    let url: any;
    const options: PushOptions = {
      android: {},
      ios: {
        alert: 'true',
        badge: "true",
        sound: 'true'
      },
      windows: {},
      browser: {
        pushServiceURL: 'http://push.api.phonegap.com/v1/push'
      }
    }
    try {
      if (this.cmndecl.BrowserBuild == 0) {
        this.push.hasPermission().then((res: any) => {
          if (res.isEnabled) {

            const pushObject: PushObject = this.push.init(options);
            pushObject.on('registration').subscribe((registration: any) => {

              localStorage.pushToken = registration.registrationId;

            }, err => {

            });
            pushObject.on('error').subscribe(error => console.error('Error with Push plugin', error));

            pushObject.on('notification').subscribe((notification: any) => {


              localStorage.notification = JSON.stringify(notification);
              if (!notification.additionalData.foreground) {
                let clickAction: any;
                clickAction = notification.additionalData.click_action.toLowerCase();
                this.updatenotification(clickAction);
                if (((clickAction == "appstore") || (clickAction == "rateus") || (clickAction == "openlink"))) {
                  url = "";
                  if (clickAction == "openlink") {
                    url = notification.additionalData.url;
                  } else {
                    if (this.cmndecl.runPlatform == 'android') {
                      url = this.cmndefinition.AppandroidUrl;
                    } else {
                      url = this.cmndefinition.AppiosUrl
                    }
                  }
                  switch (this.cmndecl.runPlatform) {
                    case "android":
                      window.open(url, '_system');
                      break;
                    case "ios":
                      window.open(url);
                      break;
                    default:
                      break;
                  }
                } else {
                  if (this.router.url == "/va/chat") {
                    this.cmndecl.functionCall = "notificationRecieaved";
                    this.cmndecl.parampassing = notification;
                  }
                }
              }
            });
          } else {
            this.push.init(options);
            const pushObject: PushObject = this.push.init(options);
            pushObject.on('registration').subscribe((registration: any) => {

              localStorage.pushToken = registration.registrationId;


            }, err => {

            });

          }
        });
      }
    } catch (e) {

    }
  }

  updatenotification(clickAction) {
    let req: any;
    let meta: any;
    if (this.cmndecl.metadata == undefined || this.cmndecl.metadata == "")
      meta = this.metaData
    else
      meta = this.cmndecl.metadata;

    req = {
      "deviceId": localStorage.pushToken,
      "clickaction": clickAction,
      "platform": this.cmndecl.runPlatform,
      "metadata": meta
    };

    this.http.post(this.Url + "setNotificationClickEvent", req, { headers: this.headers }).subscribe(data => {

    }, err => {

    })
  }

}
